var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_877_594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.997192,
    y: -0.0000762939,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_877_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33048 16.6666C3.87215 16.6666 3.47993 16.5035 3.15382 16.1774C2.82715 15.8508 2.66382 15.4583 2.66382 14.9999V4.99993C2.66382 4.54159 2.82715 4.14937 3.15382 3.82326C3.47993 3.49659 3.87215 3.33326 4.33048 3.33326H17.6638C18.1222 3.33326 18.5147 3.49659 18.8413 3.82326C19.1674 4.14937 19.3305 4.54159 19.3305 4.99993V14.9999C19.3305 15.4583 19.1674 15.8508 18.8413 16.1774C18.5147 16.5035 18.1222 16.6666 17.6638 16.6666H4.33048ZM10.9972 10.6874C11.0666 10.6874 11.1394 10.6769 11.2155 10.6558C11.2922 10.6352 11.3652 10.6041 11.4347 10.5624L17.3305 6.87493C17.4416 6.80548 17.5249 6.71882 17.5805 6.61493C17.636 6.51048 17.6638 6.39576 17.6638 6.27076C17.6638 5.99298 17.5458 5.78465 17.3097 5.64576C17.0735 5.50687 16.8305 5.51382 16.5805 5.66659L10.9972 9.16659L5.41382 5.66659C5.16382 5.51382 4.92076 5.5102 4.68465 5.65576C4.44854 5.80187 4.33048 6.00687 4.33048 6.27076C4.33048 6.40965 4.35826 6.53104 4.41382 6.63493C4.46937 6.73937 4.55271 6.81937 4.66382 6.87493L10.5597 10.5624C10.6291 10.6041 10.7022 10.6352 10.7788 10.6558C10.8549 10.6769 10.9277 10.6874 10.9972 10.6874Z",
    fill: "#242424"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.22e42f7e9bfcbc64083ddf556e547795.svg";
export { ForwardRef as ReactComponent };